import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { AosToken, aos } from './aos';
import { SafeHTMLPipe } from './pipes/safe-html.pipe';
import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './header/header.component';
import { SwiperContainerComponent, SwiperSlideComponent } from './swiper/swiper.component';
import { MenuDialogComponent } from './menu-dialog/menu-dialog.component';
import { DateDecorationPipe } from './pipes/date-decoration.pipe';
import { PriceFormatPipe } from './pipes/price-format.pipe';
import { FooterComponent } from './footer/footer.component';
import { HeaderNavComponent } from './header-nav/header-nav.component';

@NgModule({
  declarations: [
    SafeHTMLPipe,
    DateDecorationPipe,
    PriceFormatPipe,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    SwiperContainerComponent,
    SwiperSlideComponent,
    MenuDialogComponent,
    HeaderNavComponent,
  ],
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatDialogModule,
    MatSnackBarModule,
  ],
  providers: [
    { provide: AosToken, useValue: aos }
  ],
  entryComponents: [
    MenuDialogComponent,
  ],
  exports: [
    CommonModule,
    SafeHTMLPipe,
    DateDecorationPipe,
    PriceFormatPipe,
    LayoutComponent,
    HeaderComponent,
    SwiperContainerComponent,
    SwiperSlideComponent,
    MatProgressBarModule,
    MatDialogModule,
    MatSnackBarModule,
  ],
})
export class SharedModule { }
